<template>
	<el-row>
		<el-col :span="24">
			<div class="base-form header">
				<h2>
					{{ isCreatingView ? 'Новый сотрудник' : `Карточка сотрудника` }} <span>{{ `${ruleForm.lastname ?? ''} ${ ruleForm.firstname ? `${ruleForm.firstname.substring(0,1)}.` : ''}` }}</span>
				</h2>
			</div>
		</el-col>		
	</el-row>
	<el-row>
		<el-col :span="24">
			<div>
				<el-tabs class="employee-tabs" v-model="activeTab" style="margin: 0 1rem ;">
					<el-tab-pane label="Основное" name="common" v-loading="isEmployeeAsyncOperationPending">	
						<el-form :model="ruleForm" ref="employeeForm" class="base-form" status-icon :rules="rules">					
							<el-form-item v-if="!isCreatingView" label="Дата создания" label-position="top">
								<el-input v-model="ruleForm.date" :readonly="true"  />
							</el-form-item>
							
							<el-form-item label="Фамилия" label-position="top" prop="lastname">
								<el-input v-model="ruleForm.lastname" />
							</el-form-item>

							<el-form-item label="Имя" label-position="top" prop="firstname">
								<el-input v-model="ruleForm.firstname" />
							</el-form-item>

							<el-form-item label="Отчество" label-position="top" prop="middlename">
								<el-input v-model="ruleForm.middlename" />
							</el-form-item>

							<el-form-item label="Телефон" label-position="top" prop="phone">
								<input-phone-component v-model="ruleForm.phone" />
							</el-form-item>

							<el-form-item label="Почтовый адрес (e-mail)" label-position="top" prop="email">
								<el-input v-model="ruleForm.email" />
							</el-form-item>
							
							<el-form-item label="Ощущает себя" label-position="top">
								<el-radio-group v-model="ruleForm.isMale">
									<el-radio-button :value="true">Мужчиной</el-radio-button>
									<el-radio-button :value="false">Не мужчиной</el-radio-button>
								</el-radio-group>
							</el-form-item>

							<!-- Position + Grade -->
							<el-row>
								<el-col :span="11">
									<el-form-item label="Должность" label-position="top" prop="position">
										<el-select v-model="ruleForm.positionId" placeholder="Должность">
											<el-option
												v-for="e in positions"
												:key="e.id"
												:label="e.name"
												:value="e.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="2"></el-col>
								<el-col :span="11">
									<el-form-item label="Грейд" label-position="top" prop="positionGrade">
										<el-select v-model="ruleForm.gradeId" placeholder="Грейд">
											<el-option
												v-for="e in positionGrades"
												:key="e.id"
												:label="e.name"
												:value="e.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<!-- Employer + Branch -->
							<el-row>
								<el-col :span="11">
									<el-form-item label="Подразделение" label-position="top" prop="employer">
										<el-select v-model="ruleForm.employerId" placeholder="">
											<el-option
												v-for="e in employers"
												:key="e.id"
												:label="e.name"
												:value="e.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="2"></el-col>
								<el-col :span="11">
									<el-form-item label="Бранч" label-position="top" prop="employerBranch">
										<el-select v-model="ruleForm.employerBranchId" placeholder="">
											<el-option
												v-for="e in employerBranches"
												:key="e.id"
												:label="e.name"
												:value="e.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<el-form-item label="Дата оформления в штат" label-position="top" prop="hireDate">
								<el-date-picker
									v-model="ruleForm.hireDate"
									type="date"
									format="DD.MM.YYYY"
									placeholder="Дата оформления"
								/>
							</el-form-item>

							<el-form-item label="Дата рождения" label-position="top" prop="birthdate">
								<el-date-picker
									v-model="ruleForm.birthdate"
									type="date"
									format="DD.MM.YYYY"
									placeholder="Выберите дату рождения"
								/>
							</el-form-item>

							<el-form-item :label="employee?.user?.login ? 'Пользователь' : ''" v-if="!isCreatingView" label-position="top">
								<el-text class="mx-1" type="primary" v-if="employee?.user?.login">{{ employee.user.login }}</el-text>
								<div v-else>
									<el-text>пользователь не создан&nbsp;<el-link style="line-height: 18px; margin-top: -3px" type="primary" @click="onCreateAndLinkUserClick">создать</el-link></el-text>
								</div>
							</el-form-item>

							<el-form-item label="Увольнение" v-if="!isCreatingView" label-position="top">
								<el-checkbox v-model="ruleForm.isFired" label="Уволен" size="large" />
								&nbsp;
								<el-date-picker
									:disabled="!ruleForm.isFired" 
									v-model="ruleForm.fireDate"
									type="date"
									format="DD.MM.YYYY"
									placeholder="Выберите дату"
								/>
							</el-form-item>

							<el-form-item label="Заметки" label-position="top">
								<el-input							
									v-model="ruleForm.notes"
									maxlength="5000"
									show-word-limit
									type="textarea"
									placeholder="Заметки (опционально)"
								/>
							</el-form-item>	
							
							<el-form-item>
								<el-button type="primary" @click="onUpdateEmployeeClick" v-if="!isCreatingView">
									Сохранить
								</el-button>
								<el-button type="primary" @click="onCreateEmployeeClick" v-if="isCreatingView">
									Создать
								</el-button>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="График работы" name="schedule" :disabled="isCreatingView">
						<employee-schedule-component 
							v-if="!isCreatingView && activeTab == 'schedule'" 
							:employee-id="employee!.id" 
						/>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import CatalogPickerComponent from '@/components/CatalogPickerComponent.vue';
import { ElButton, ElTable, ElLink, FormInstance, ElNotification } from 'element-plus';
import { date as dateFormatter } from '@/helpers/formatters';
import { reactive } from 'vue';
import axiosHelper from '@/helpers/axiosHelper';
import store from '@/store';
import EmployeeModel from '@/models/EmployeeModel';
import EventHelper from '@/helpers/eventsHelper';
import TabsDictionary from '@/variables/tabs';
import EmployeePositionModel from '@/models/EmployeePositionModel';
import EmployeePositionGradeModel from '@/models/EmployeePositionGradeModel';
import LegalEntityModel from '@/models/LegalEntityModel';
import LegalEntityBranchModel from '@/models/LegalEntityBranchModel';
import ApplicationTab from '@/models/ApplicationTab';
import { AxiosInstance } from 'axios';
import InputPhoneComponent from '@/components/InputPhoneComponent.vue';
import EmployeeScheduleComponent from '@/components/employee/EmployeeScheduleComponent.vue';

@Options({
	components: {
		ElButton, ElTable, ElLink, CatalogPickerComponent, InputPhoneComponent,
		EmployeeScheduleComponent
	},
	props: {
		params: Array
	}
})
export default class EmployeeView extends Vue {
	/** params */
	params!: Array<any>;
	employee: EmployeeModel | null = null;
	isCreatingView = false;

	/** constants */
	positions: Array<EmployeePositionModel> = [];
	positionGrades: Array<EmployeePositionGradeModel> = [];
	employers: Array<LegalEntityModel> = [];
	employerBranches: Array<LegalEntityBranchModel> = [];

	userLoginAvailHttpClient: AxiosInstance | null = null;
	phoneValidationHttpClient: AxiosInstance | null = null;

	/** view-models */		
	isEmployeeAsyncOperationPending = true;
	activeTab = 'common';
	ruleForm = reactive({
		id: 0,
		date: '',
		lastname: null,
		firstname: null,
		middlename: null,
		phone: null,
		email: null,
		isMale: true,
		hireDate: new Date(),
		birthdate: null,
		fireDate: null,
		isFired: false,
		employee: null,
		notes: null,

		employerId: null,
		employerBranchId: null,
		positionId: null,
		gradeId: null,
		userId: null,
	});

	rules = reactive({
		lastname: [			
			{ required: true, message: 'Фамилия не может быть пустой'},
			{ min: 1, max: 255, message: 'Фамилия не может быть короче 1 и длинее 255 символов'}			
		],
		firstname: [			
			{ required: true, message: 'Имя не может быть пустым'},
			{ min: 1, max: 255, message: 'Имя не может быть короче 1 и длинее 255 символов'}
		],
		middlename: [						
			{ min: 1, max: 255, message: 'Отчество не может быть короче 1 и длинее 255 символов'}
		],
		phone: [
			{ required: true, message: 'Телефон сотрудника не может быть пустым'},	
			{ min: 10, max: 255, message: 'Номер не может быть короче 10 и длинее 255 символов'},
			{ validator: async (a: any, b: string, c: any) => await this.phoneValidatorAsync(a,b,c) }
		],
		hireDate: [						
			{ required: true, message: 'Дата оформления не может быть пустой'},
		],
		birthdate: [						
			{ required: true, message: 'Дата рождения не может быть пустой'},
		],
		position: [			
			{ validator: (a: any, b: number, c: any) => this.positionValidator(a,b,c) }
		],
		positionGrade: [
			{ validator: (a: any, b: number, c: any) => this.positionGradeValidator(a,b,c) }			
		],
		employer: [
			{ validator: (a: any, b: number, c: any) => this.employerValidator(a,b,c) }	
		],
		employerBranch: [
			{ validator: (a: any, b: number, c: any) => this.employerBranchValidator(a,b,c) }	
		]
	});
	
	mounted() {
		const jwt = store.getters.jwt
		this.userLoginAvailHttpClient = axiosHelper.createInstance(jwt);
		this.phoneValidationHttpClient = axiosHelper.createInstance(jwt);
		
		Promise.all([
			this.initForm(),
			this.fetchEmployeePositionsAsync(), 
			this.fetchEmployeePositionGradesAsync(),
			this.fetchEmployersAsync()
		]).finally(() => this.isEmployeeAsyncOperationPending = false);
	}

	/**
	 * init form with user's data from incoming parameters array (params)
	 */
	initForm() {
		if (!this.params?.length ||
			this.params[1] == true) {
			this.isCreatingView = true;
			return;
		}

		this.employee = this.params[0] as EmployeeModel | null;

		if (this.employee?.id) {
			this.ruleForm.id = this.employee?.id as any;
			this.ruleForm.date = dateFormatter.dateTime(this.employee?.date, true, true);
			this.ruleForm.lastname = this.employee?.lastname as any;
			this.ruleForm.firstname = this.employee?.firstname as any;
			this.ruleForm.middlename = this.employee?.middlename as any;
			this.ruleForm.phone = this.employee?.phone as any;
			this.ruleForm.email = this.employee?.email as any;
			this.ruleForm.isMale = this.employee?.isMale as any;
			this.ruleForm.hireDate = this.employee?.hireDate as any;
			this.ruleForm.birthdate = this.employee?.birthdate as any;
			this.ruleForm.fireDate = this.employee?.fireDate as any;
			this.ruleForm.isFired = !!this.employee?.fireDate;
			this.ruleForm.notes = this.employee?.notes as any;
			this.ruleForm.employerId = this.employee?.employer?.id as any;
			this.ruleForm.employerBranchId = this.employee?.employerBranch?.id as any;
			this.ruleForm.positionId = this.employee?.position?.id as any;
			this.ruleForm.gradeId = this.employee?.positionGrade?.id as any;
			this.ruleForm.userId = this.employee?.user?.id as any;			
			return;
		}

		this.isCreatingView = true;
	}

	async fetchEmployersAsync() {		
		try {
			const jwt = store.getters.jwt
			const legalEntitiesHttpClient = axiosHelper.createInstance(jwt);
			const response = await legalEntitiesHttpClient.get('/api/legalentities/executives');
			this.employers = response.data;

			if (this.employers?.length == 1) {
				const employer: LegalEntityModel = this.employers[0];
				this.ruleForm.employerId = employer.id as any;

				if (employer.branches?.length == 1) {
					this.employerBranches = [ employer.branches[0] ];
					this.ruleForm.employerBranchId = employer.branches[0].id as any;
				}
			}
		} catch (e: any) {
			console.error('Error loading employers list', e)
		}
	}

	async fetchEmployeePositionsAsync() {
		try {
			const jwt = store.getters.jwt
			const employeePositionsHttpClient = axiosHelper.createInstance(jwt);
			const response = await employeePositionsHttpClient.get('/api/employees/positions');
			this.positions = response.data;			
		} catch (e: any) {
			console.error('Error loading employee positions list', e)
		}
	}

	async fetchEmployeePositionGradesAsync() {
		try {
			const jwt = store.getters.jwt
			const employeePositionGradesHttpClient = axiosHelper.createInstance(jwt);
			const response = await employeePositionGradesHttpClient.get('/api/employees/positiongrades');
			this.positionGrades = response.data;			
		} catch (e: any) {
			console.error('Error loading employee position grades list', e)
		}
	}

	async onUpdateEmployeeClick() {		
		const form = this.$refs.employeeForm as FormInstance;
		form.validate(async (valid) => {
			if (valid) {
				this.isEmployeeAsyncOperationPending = true;

				try {
					const fireDate = this.ruleForm.isFired ? this.ruleForm.fireDate : null;

					const request = {		
						id: this.ruleForm.id,			
						firstname: this.ruleForm.firstname,
						lastname: this.ruleForm.lastname,
						middlename: this.ruleForm.middlename,
						isMale: this.ruleForm.isMale,
						employerId: this.ruleForm.employerId,
						employerBranchId: this.ruleForm.employerBranchId,
						hireDate: this.ruleForm.hireDate,
						fireDate: fireDate,
						positionId: this.ruleForm.positionId,
						positionGradeId: this.ruleForm.gradeId,
						birthdate: this.ruleForm.birthdate,
						phone: this.ruleForm.phone,
						email: this.ruleForm.email,						 
						notes: this.ruleForm.notes
					};
					const jwt = store.getters.jwt
					const updateEmployeeHttpClient = axiosHelper.createInstance(jwt);
					const response = await updateEmployeeHttpClient.put('/api/employees', request);
					if (response.data?.id) {
						ElNotification({
							title: 'Пользователь обновлен',
							message: `Пользователь id ${this.employee!.id} обновлен'`,
							type: 'success',
						});
						this.closeCurrentTab();
						EventHelper.dispatchEvent('employeesUpdate');
					} else {												
						throw new Error('Unexpected response');
					}
				} catch (e: any) {
					if (e.code == 'ERR_NETWORK') {
						ElNotification({
							title: 'Ошибка',
							message: `Ошибка соединения, не удалось сохранить данные`,
							type: 'error',
						});
					} else {
						ElNotification({
							title: 'Ошибка',
							message: `Ошибка сохранения данных пользователя`,
							type: 'error',
						});
					}
					console.error('Error updating employee', e);
				}
				finally {
					this.isEmployeeAsyncOperationPending = false;
				}
			}
		});
	}

	async onCreateEmployeeClick() {
		const form = this.$refs.employeeForm as FormInstance;
		form.validate(async (valid) => {
			if (valid) {
				this.isEmployeeAsyncOperationPending = true;	
				
				try {
					const request = {						
						firstname: this.ruleForm.firstname,
						lastname: this.ruleForm.lastname,
						middlename: this.ruleForm.middlename,
						isMale: this.ruleForm.isMale,
						employerId: this.ruleForm.employerId,
						employerBranchId: this.ruleForm.employerBranchId,						
						positionId: this.ruleForm.positionId,
						positionGradeId: this.ruleForm.gradeId,
						birthdate: this.ruleForm.birthdate,
						hireDate: this.ruleForm.hireDate,
						phone: this.ruleForm.phone,
						email: this.ruleForm.email,						 
						notes: this.ruleForm.notes
					};
					const jwt = store.getters.jwt
					const addEmployeeHttpClient = axiosHelper.createInstance(jwt);
					const response = await addEmployeeHttpClient.post('/api/employees', request);
					if (response.data?.id) {
						ElNotification({
							message: `Сотрудник успешно создан`,
							type: 'success',
						});
						this.closeCurrentTab();
						EventHelper.dispatchEvent('employeesUpdate');
					} else {												
						throw new Error('Unexpected response');
					}
				} catch (e: any) {
					if (e.code == 'ERR_NETWORK') {
						ElNotification({
							message: `Ошибка соединения, не удалось создать нового сотрудника`,
							type: 'error',
						});
					} else {
						ElNotification({							
							message: `Ошибка создания нового сотрудника`,
							type: 'error',
						});
					}
					console.error('Error creating employee', e);
				}
				finally {
					this.isEmployeeAsyncOperationPending = false;
				}
			}
		});
	}

	async loginAvailabilityValidator(rule: any, value: string, callback: any) {		
		try {
			await this.userLoginAvailHttpClient?.get(`/api/users/login_avail/${value}`);
		} catch (e) {
			callback(new Error(`Логин '${value}' уже используется`));
		}
	}

	onCreateAndLinkUserClick() {
		const addUserTab = TabsDictionary.userAdd;
		const isAddingNewUserForm = true;
		addUserTab.params = [ null, isAddingNewUserForm, this.employee ];
		store.commit('addTab', addUserTab);
		const newTab = store.getters.newlyAddedTab as ApplicationTab;
		store.commit('changeTab', newTab.id);
	}

	closeCurrentTab() {		
		store.commit('removeTab', store.getters.tab);
	}

	positionValidator(rule: any, positioId: number, callback: any) {		
		if (!this.ruleForm.positionId) {
			callback(new Error('Укажите должность'));
			return false;
		}
		return true;
	}

	positionGradeValidator(rule: any, gradeId: number, callback: any) {		
		if (!this.ruleForm.gradeId) {
			callback(new Error('Укажите грейд'));
			return false;
		}
		return true;
	}

	employerValidator(rule: any, employerId: number, callback: any) {		
		if (!this.ruleForm.employerId) {
			callback(new Error('Укажите подразделение'));
			return false;
		}
		return true;
	}

	employerBranchValidator(rule: any, employerBranchId: number, callback: any) {		
		if (!this.ruleForm.employerBranchId) {
			callback(new Error('Укажите бранч подразделения'));
			return false;
		}
		return true;
	}

	async phoneValidatorAsync(rule: any, phone: string, callback: any) {
		const p = this.ruleForm.phone;
		const url = this.isCreatingView ?
			`/api/employees/phone/${p}` : 
			`/api/employees/noninclusivephone/${p}/${this.employee?.id}`
		try {			
			await this.phoneValidationHttpClient?.get(url);
		} catch (e) {
			callback(new Error(`Телефон '${p}' уже используется`));
		}
		return true;
	}
}
</script>

<style>
.employee-tabs {
	margin: 0 0 15px;
	border-bottom: 2px solid var(--el-border-color-light)
}

	.employee-tabs div.is-active {
		border-top: 0!important
	}

	.employee-tabs .el-tabs__content {
		min-height: 610px;
	}

	.highlighted-placeholder {
		background: var(--el-color-primary-light-9);		
		border-radius: var(--el-border-radius-base);
		margin: 0 1rem;
		padding: 0 1rem;
		line-height: 2.8rem;
		min-width: 2.28rem; 
		font-size: 2.28rem;
	}

		.highlighted-placeholder.colored-font {			
			color: var(--el-color-primary);
		}

		.highlighted-placeholder.editable {			
			outline: none;
			cursor: text;
		}
</style>